
interface RegionNameFormatterProps {
  region: string;
}

export default (props: RegionNameFormatterProps) => {
  if (!props.region.startsWith("amazon-web-services::")) {
    return (<span>props.region</span>); // Do not format if region does not match expected format
  }

  const regionCode = props.region.split("::")[1];
  const parts = regionCode.split("-");
  const polity = parts[0].toUpperCase();
  const subGeo = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);

  return (<span>{`${polity} ${subGeo}`}</span>);
}
